/**
 * Exhaustive-switch helper: assign the default case to `never` so missing
 * union variants fail at compile time. See docs/fp-conventions.md.
 */
export function assertNever(x: never): never {
  throw new Error(`unexpected: ${String(x)}`);
}
